



































import PageContainer from '@/general/component/PageContainer.vue';
import Component from 'vue-class-component';
import CustomerRouter, { customerRouter } from '@/context/customer/router/CustomerRouter';
import { AxiosResponse } from 'axios';
import { customerApi } from '@/context/customer/api/CustomerApi';
import { CustomerFilter } from '@/context/customer/model/CustomerFilter';
import Vue from 'vue';
import { Api } from '@/common/api/Api';
import TextInput from '@/general/component/form/input/TextInput.vue';

@Component({
  components: { TextInput, PageContainer }
})
export default class CustomerListContainer extends Vue {
  router: CustomerRouter = customerRouter;
  deleteApi: (id: number) => Promise<AxiosResponse> = customerApi.delete;
  filter: CustomerFilter = new CustomerFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Nazwa",
      value: "name",
      align: "left"
    }
  ];
  api: Api = customerApi;
}
